// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32qRD","col":"styles_col__1h06C"};